<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-ticker-services" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'menu:TickerServices' | i18next : { defaultValue: 'Ticker Services' } }}</span>
    <div class="right">
      <app-filter-input id="filter-input-ticker-services" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
      <div class="toggleButtons" style="margin-left: 24px;">
        <app-basic-button id="day-window-btn-ticker-services" [type]="selectedWindow === 'day' ? 'primary' : 'secondary'" [text]="'ticker:day' | i18next" fontSize="12px"
        size="small" (click)="onSelectWindow('day')" [dropShadow]="false"></app-basic-button>
        <app-basic-button id="week-window-btn-ticker-services" [type]="selectedWindow === 'week' ? 'primary' : 'secondary'" [text]="'ticker:week' | i18next" fontSize="12px"
        size="small" (click)="onSelectWindow('week')" [dropShadow]="false"></app-basic-button>
      </div>
    </div>
  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

      <!-- Access Point -->
      <ng-container matColumnDef="accessPoint">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_accessPoint' | i18next : { defaultValue: 'Access point' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left">
          {{ r.accessPoint }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="left">
          {{ totals?.statisticsTitle || ('ticker:statistics_title' | i18next : { defaultValue: 'Totals' }) }}
        </td>
      </ng-container>

      <!-- Description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_description' | i18next : { defaultValue: 'Description' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left">
          {{ r.description }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="left">
          <!-- blank in totals row to match old UI -->
        </td>
      </ng-container>

      <!-- Total Received -->
      <ng-container matColumnDef="totalReceived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_totalReceived' | i18next : { defaultValue: 'Total received' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.totalReceived }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ totals?.formattedTotalReceived || '—' }}
        </td>
      </ng-container>

      <!-- Total Answered -->
      <ng-container matColumnDef="totalAnswered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_totalAnswered' | i18next : { defaultValue: 'Total answered' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.totalAnswered }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ totals?.formattedTotalAnswered || '—' }}
        </td>
      </ng-container>

      <!-- Answer % -->
      <ng-container matColumnDef="answerPercent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_answerPercent' | i18next : { defaultValue: 'Answer %' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{!r.formattedAnswerPercent || r.formattedAnswerPercent=="NaN"?('ticker:NaN' | i18next):r.formattedAnswerPercent }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{!totals?.formattedAnswerPercent || totals?.formattedAnswerPercent=="NaN"?('ticker:NaN' | i18next):totals?.formattedAnswerPercent }}
        </td>
      </ng-container>

      <!-- Header, rows, footer -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>

      <tr mat-footer-row *matFooterRowDef="displayedFooterColumns" [hidden]="dataSource.filteredData.length == 0"></tr>
    </table>
  </div>
</div>
